/* Strong 100 page behavior: countdowns, sticky bar, free-challenge modal.
   Safe to load from multiple sections; initializes once. */
(function () {
  if (window.__s100Init) return;
  window.__s100Init = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---- Countdowns: any element with [data-s100-deadline] ---- */
  function tick() {
    var els = document.querySelectorAll('[data-s100-deadline]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var t = new Date(el.getAttribute('data-s100-deadline'));
      if (isNaN(t.getTime())) continue;
      var diff = t - new Date();
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff % 86400000 / 3600000);
      var m = Math.floor(diff % 3600000 / 60000);
      var s = Math.floor(diff % 60000 / 1000);
      var set = function (cls, val) {
        var n = el.querySelector(cls);
        if (n) n.textContent = pad(val);
      };
      set('.s100-cd-d', d); set('.s100-cd-h', h); set('.s100-cd-m', m); set('.s100-cd-s', s);
    }
  }
  tick();
  setInterval(tick, 1000);

  /* ---- Sticky bar: shows after scrolling past the hero section ---- */
  function onScroll() {
    var bar = document.querySelector('.s100-topbar');
    if (!bar) return;
    var hero = document.querySelector('.s100-hero');
    var threshold = hero ? (hero.offsetTop + hero.offsetHeight - 80) : 600;
    if (window.scrollY > threshold) bar.classList.add('s100-show');
    else bar.classList.remove('s100-show');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- Free challenge modal ---- */
  function openModal() {
    var m = document.getElementById('s100-free-modal');
    if (!m) return;
    m.classList.add('s100-open');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    var m = document.getElementById('s100-free-modal');
    if (!m) return;
    m.classList.remove('s100-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-s100-open-free]');
    if (opener) { e.preventDefault(); openModal(); return; }
    if (e.target.closest('[data-s100-close-free]')) { e.preventDefault(); closeModal(); return; }
    var overlay = document.getElementById('s100-free-modal');
    if (overlay && e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
